import {Http} from 'src/utils/http';

export async function apiInit() {
  return Http.Post('/init/query-init')
}

export async function exportQueryList() {
  return Http.Post('/export/mgmt/query-list', null, '/system')
}

export async function exportBatchDelete() {
  return Http.Post('/export/mgmt/batch-delete', null, '/system')
}

export async function exportUser() {
  return Http.Post('/demo/mgmt/export-user', null, '/system')
}

export async function exportDelete(params?: any) {
  return Http.Post('/export/mgmt/delete', params, '/system')
}

export async function download(url) {
  url = '/bg/system/file/mgmt/' + url;
  return Http.DownloadFile(url);
}

export async function downloadExport(fileId) {
  return Http.DownloadFile('/bg/system/file/mgmt/export/get/' + fileId);
}

export async function UploadFile(file, onUploadProgress?) {
  return Http.UploadFile(file, onUploadProgress);
}

// CB7REQ-136 遊戲圖片固定路徑上傳
export async function UploadGameImg(params, onUploadProgress?) {
  return Http.UploadGameImg(params, onUploadProgress);
}

export async function getWebsiteConfigList(params?: any) {
  return Http.Post('/setting/config/mgmt/query-list/v2/getWebsiteConfigList', params, '/dispset');
}

// 新版本接口，用於新建的配置頁面
export async function getWebsiteConfigListV2(params?: any) {
  return Http.Post('/setting/config/mgmt/query-list/v2/getWebsiteConfigList', params, '/dispset');
}

export async function getCommonConfigList() {
  return Http.Post('/setting/config/mgmt/query-list/getCommonConfigList', null, '/dispset');
}

export async function updateBatchWebsiteConfig(params: any) {
  return Http.Post('/setting/config/mgmt/update/v2/updateBatchWebsiteConfig', params, '/dispset');
}

// 新版本接口，用於新建的配置頁面
export async function updateBatchWebsiteConfigV2(params: any) {
  return Http.Post('/setting/config/mgmt/update/v2/updateBatchWebsiteConfig', params, '/dispset');
}

export async function getKycConfigList(params?: any) {
  return Http.Post('/kycconfig/mgmt/query-list/getWebsiteConfigList', params, '/dispset');
}

export async function updateBatchKycConfig(params: any) {
  return Http.Post('/kycconfig/mgmt/update/updateBatchWebsiteConfig', params, '/dispset');
}

export async function getMobileUpgradeConfigList(params?: any) {
  return Http.Post('/mobileupgradeconfig/mgmt/query-list/get-mobile-upgrade-config-list', params, '/dispset');
}

export async function updateMobileUpgradeConfig(params: any) {
  return Http.Post('/mobileupgradeconfig/mgmt/update/update-mobile-upgrade-config', params, '/dispset');
}

export async function freezeMobileUpgradeConfig(params: any) {
  return Http.Post('/mobileupgradeconfig/mgmt/update/freeze-mobile-upgrade-config', params, '/dispset');
}

export async function unfreezeMobileUpgradeConfig(params: any) {
  return Http.Post('/mobileupgradeconfig/mgmt/update/unfreeze-mobile-upgrade-config', params, '/dispset');
}

export async function deleteMobileUpgradeConfig(params: any) {
  return Http.Post('/mobileupgradeconfig/mgmt/delete/delete-mobile-upgrade-config', params, '/dispset');
}

export async function getSmsSupplyList(params: any) {
  return Http.Post('/smssupply/mgmt/query-list/get-sms-supply-list/get-sms-supply-list', params, '/external');
}
export async function freezeSmsSupply(params: any) {
  return Http.Post('/smssupply/mgmt/update/freeze-sms-supply/freeze-sms-supply', params, '/external');
}
export async function unfreezeSmsSupply(params: any) {
  return Http.Post('/smssupply/mgmt/update/unfreeze-sms-supply/unfreeze-sms-supply', params, '/external');
}
export async function getDictListByGroup(groupCode: any) {
  return Http.FormPost('/base/data/query-list/get-dict-list-by-group', {groupCode: groupCode || '10001'}, '/dispset');
}

export async function getAdsAgentList(params: any) {
  return Http.Post('/adsagent/mgmt/query-list/get-ads-agent-list', params, '/external');
}
export async function createAdsAgent(params: any) {
  return Http.Post('/adsagent/mgmt/create/create-ads-agent', params, '/external');
}
export async function deleteAdsAgent(params: any) {
  return Http.Post('/adsagent/mgmt/delete/delete-ads-agent', params, '/external');
}

export async function getAdsAccountList(params: any) {
  return Http.Post('/adsaccount/mgmt/query-list/get-ads-account-list', params, '/external');
}

export async function createAdsAccount(params: any) {
  return Http.Post('/adsaccount/mgmt/create/create-ads-account', params, '/external');
}
export async function updateAdsAccount(params: any) {
  return Http.Post('/adsaccount/mgmt/update/update-ads-account', params, '/external');
}
export async function deleteAdsAccount(params: any) {
  return Http.Post('/adsaccount/mgmt/delete/delete-ads-account', params, '/external');
}


export async function getAdsMccAccountList(params: any) {
  return Http.Post('/adsmccaccount/mgmt/query-list/get-ads-mcc-account-list', params, '/external');
}
export async function createAdsMccAccount(params: any) {
  return Http.Post('/adsmccaccount/mgmt/create/create-ads-mcc-account', params, '/external');
}
export async function deleteAdsMccAccount(params?: any) {
  return Http.Post('/adsmccaccount/mgmt/delete/delete-ads-mcc-account', params, '/external');
}

export async function getAdsAccountType() {
  return Http.FormPost('/base/data/query-list/get-dict-list-by-group', {groupCode:'80004'}, '/dispset');
}

export async function getAdsEvent() {
  return Http.FormPost('/base/data/query-list/get-dict-list-by-group', {groupCode:'80005'}, '/dispset');
}
export async function getAdsPushStatus() {
  return Http.FormPost('/base/data/query-list/get-dict-list-by-group', {groupCode:'80006'}, '/dispset');
}

export async function getAdsReportList(params?: any) {
  return Http.Post('/adsreport/mgmt/query-list/get-ads-report-list', params, '/external');
}

export async function exportAdsReport(params?: any) {
  return Http.Post('/adsreport/mgmt/export/export-ads-report', params, '/external');
}

export async function getAdsUserPushRecordList(params?: any) {
  return Http.Post('/adsuserpushrecord/mgmt/query-list/get-ads-user-push-record-list', params, '/external');
}
export async function retryAllFailedRecords(params?: any) {
  return Http.Post('/adsuserpushrecord/mgmt/update/batch-retry-all-failed-records', params, '/external');
}
export async function retryPushRecord(params?: any) {
  return Http.Post('/adsuserpushrecord/mgmt/update/retry-push-record', params, '/external');
}

